import { forwardRef, type InputHTMLAttributes } from "react";

import { cn } from "@/lib/utils";

export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  ({ className, type = "text", ...props }, ref) => (
    <input
      type={type}
      ref={ref}
      className={cn(
        "flex h-10 w-full rounded border border-border bg-surface px-3 py-2 text-sm",
        // Un nombre se lit par la droite : les unités sous les unités, les
        // milliers sous les milliers. Les tableaux le faisaient déjà, les
        // champs de saisie non — un montant se composait donc à gauche puis
        // s'affichait à droite une fois enregistré. `tabular-nums` fige la
        // largeur des chiffres pour que la colonne ne danse pas à la frappe.
        type === "number" && "text-right tabular-nums",
        // Valeur saisie en quasi-noir (contraste AA renforcé). Sans couleur
        // explicite, l'input hérite de `text-muted-foreground` du body et paraît
        // délavé. Le placeholder reste volontairement plus clair.
        "text-stone-900 dark:text-stone-100",
        "ring-offset-background placeholder:text-muted",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2",
        "disabled:cursor-not-allowed disabled:opacity-50",
        className,
      )}
      {...props}
    />
  ),
);
Input.displayName = "Input";
